import * as React from 'react';

const CheckCircleFilled24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m11 15.56-3.53-3.53 1.06-1.06L11 13.44l4.47-4.47 1.06 1.06L11 15.56zM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" }));
CheckCircleFilled24.Size = 24;
CheckCircleFilled24.Title = "CheckCircleFilled";

export { CheckCircleFilled24 as default };
